import gql from 'graphql-tag'

export const DEACTIVATE_PAGE = gql`
    mutation deactivatePage($pageID: ID!, $website: ID!) {
        deactivatePage(pageID: $pageID, website: $website) {
            statusCode
            success
        }
    }
`
